import { useRef, useState } from "react";
import { Button } from "../../components/buttons/button";
import { MiniHeader } from "../../components/typography/miniHeader";
import { PageHeader } from "../../components/typography/pageHeader";
import { BgWrapper } from "../../components/wrapper/bgWrapper";
import { PayoutSettings } from "./payoutSettings";
import { ProfileSettings } from "./profileSettings";
import { SecuritySettings } from "./securitySettings";

type Section = "profile" | "payouts" | "security";

const sectionActions: {
  title: string;
  to: Section;
  icon: string;
}[] = [
  { title: "Profile", to: "profile", icon: "avatar" },
  { title: "Payout", to: "payouts", icon: "bank" },
  { title: "Security", to: "security", icon: "shield" },
];

export const Settings = () => {
  const [activeSection, setActiveSection] = useState<Section>("profile");

  const pageRefs = useRef<HTMLDivElement[] | null>([]);

  return (
    <div className="w-full">
      <PageHeader header={"Account Settings"} />

      <div className="relative mt-8 flex items-start gap-0">
        <div className="sticky top-0 hidden h-fit w-full max-w-[200px] flex-col md:flex">
          {sectionActions.map((section, idx) => {
            return (
              <Button
                key={section.to}
                onClick={() => {
                  setActiveSection(section.to);
                  if (pageRefs.current && pageRefs.current.length > idx) {
                    pageRefs.current[idx].scrollIntoView({
                      behavior: "smooth",
                    });
                  }
                }}
                icon={section.icon}
                iconDimension={20}
                iconClassName="text-grey-400"
                type="button"
                variation={activeSection === section.to ? "white" : "bland"}
                text={section.title}
                className="!justify-start !rounded-2xl !p-3 !text-left !text-sm"
              />
            );
          })}
        </div>

        <div className="flex flex-1 justify-center md:px-4">
          <div className="flex w-full max-w-[628px] flex-col gap-2.5 md:pb-80">
            <div
              className="flex w-full flex-col gap-[2px]"
              ref={(el) => {
                if (pageRefs.current && el) {
                  pageRefs.current[0] = el;
                }
              }}
            >
              <BgWrapper>
                <MiniHeader header="Profile" />
              </BgWrapper>
              <ProfileSettings
                onEditSuccess={() => {
                  if (pageRefs.current && pageRefs.current.length > 0) {
                    pageRefs.current[0].scrollIntoView({
                      behavior: "smooth",
                    });
                  }
                }}
              />
            </div>

            <div
              className="flex w-full flex-col gap-[2px]"
              ref={(el) => {
                if (pageRefs.current && el) {
                  pageRefs.current[1] = el;
                }
              }}
            >
              <BgWrapper>
                <MiniHeader header="Payout Details" />
              </BgWrapper>
              <PayoutSettings />
            </div>

            <div
              className="flex w-full flex-col gap-[2px]"
              ref={(el) => {
                if (pageRefs.current && el) {
                  pageRefs.current[2] = el;
                }
              }}
            >
              <BgWrapper className="flex items-center justify-between gap-3">
                <MiniHeader header="Security" />
              </BgWrapper>
              <SecuritySettings />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
